const { default: parentApi } = require("store/parentApi");

const testApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    getQuestionsForTest: build.query({
      query: (body) => {
        return {
          url: `/test/getTest`,
          method: "POST",
          body: body,
        };
      },
    }),
    getAnsweredQuestions: build.query({
      query: (body) => {
        return {
          url: `/question/getAnsweredQuestions`,
          method: "POST",
          body: body,
        };
      },
    }),
    createTest: build.mutation({
      query: (body) => {
        return {
          url: `/test/createTest`,
          method: "POST",
          body: body,
        };
      },
    }),
    startTest: build.mutation({
      query: (body) => {
        return {
          url: `/test/startTest`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["quizDetails"],
    }),
    resetTest: build.mutation({
      query: (body) => {
        return {
          url: `/quiz/resetQuiz`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["quizDetails"],
    }),
  }),
});

export const {
  useLazyGetQuestionsForTestQuery,
  useCreateTestMutation,
  useStartTestMutation,
  useResetTestMutation,
  useGetAnsweredQuestionsQuery,
} = testApis;
